
/**
 * Active request cancellation
 * Call abortAllRequests() to cancel every in-flight fetch (e.g. on logout).
 */
let _controller = new AbortController();

export function abortAllRequests () {
    _controller.abort();
    _controller = new AbortController();
}

export function getSignal (): AbortSignal {
    return _controller.signal;
}

/**
 * Environment
 */
const env: 'dev' | 'staging' | 'prod' = 'prod';
const apiURL: string = 'https://api.gamenostic.gg/console/';

/**
 * URLS
 */
export const URL = {
    AUTH_LOGIN: `${apiURL}user/auth`,
    AUTH_GET_USER: `${apiURL}user/getuser`,
    AUTH_UPDATE_SETTINGS: `${apiURL}user/update`,
    AUTH_REMOVE_ACCOUNT: `${apiURL}user/remove`,
    AUTH_BILLING_SETUP_INTENT: `${apiURL}user/billingsetupintent`,
    AUTH_BILLING_REMOVE_PAYMENT_METHOD: `${apiURL}user/billingremovepaymentmethod`,
    ADMIN_DASHBOARD_GET: `${apiURL}admin/get`,
    ADMIN_PROJECT_COSTS_GET: `${apiURL}admin/getprojectcosts`,
    ADMIN_UPDATE_USER_ROLE: `${apiURL}admin/updateuserrole`,
    ADMIN_BLOCK_PROJECT: `${apiURL}admin/blockproject`,
    ADMIN_UNBLOCK_PROJECT: `${apiURL}admin/unblockproject`,
    ADMIN_BILLING_TIERS_ADD: `${apiURL}admin/addbillingtier`,
    ADMIN_BILLING_TIERS_UPDATE: `${apiURL}admin/updatebillingtier`,
    ADMIN_BILLING_TIERS_DELETE: `${apiURL}admin/deletebillingtier`,
    ANALYTICS_DATA_GET: `${apiURL}data/get`,
    ANALYTICS_DATA_PROJECT_GET: `${apiURL}data/project`,
    ANALYTICS_DATA_USER_GET: `${apiURL}data/user`,
    ANALYTICS_DATA_PROJECT_SYMBOLIC_FILES_STATS_GET: `${apiURL}data/projectsymbolicfiles`,
    ANALYTICS_DATA_CRASH_GROUP_GET: `${apiURL}data/crashgroup`,
    ANALYTICS_DATA_CRASH_GROUP_UPDATE: `${apiURL}data/updatecrashgroup`,
    PROJECTS_GET: `${apiURL}projects/get`,
    PROJECTS_ADD: `${apiURL}projects/add`,
    PROJECTS_UPDATE: `${apiURL}projects/update`,
    PROJECTS_UPDATE_BILLING_TIER: `${apiURL}projects/updatebillingtier`,
    PROJECTS_DELETE: `${apiURL}projects/delete`,
    EARLY_ACCESS_SUBMIT: `${apiURL}earlyAccess/apply`,
    SLACK_ASSIGN: `${apiURL}slackapi/assign`,
    SLACK_REVOKE: `${apiURL}slackapi/revoke`,
    SLACK_UPDATE: `${apiURL}slackapi/update`,
    DISCORD_ASSIGN: `${apiURL}discordapi/assign`,
    DISCORD_REVOKE: `${apiURL}discordapi/revoke`,
    DISCORD_UPDATE: `${apiURL}discordapi/update`,
    EMAIL_UNSUBSCRIBE: `${apiURL}unsubscribeColaborationEmail`,
}

/**
 * Web Socket Connections
 */
export const WS = {
    LIVE_DATA_CONNECTION:`wss://6xc008xhrf.execute-api.us-east-1.amazonaws.com/${env}`
}
/**
 *
 * @param url {string} - request url
 * @param params {RequestInit} request body
 */
export async function httpRequest (url: string, params: RequestInit | undefined):Promise<Response> {
    const response = await fetch(url, { signal: getSignal(), ...params });
    return response;
}